import type { UpdateStatus } from './types';
import { cn } from '../cn';
import { Alerts, General } from '../StrokeIcons';
import WaveSpinner from '../WaveSpinner/WaveSpinner';

export type UpdateStatusIconProps = {
  status: UpdateStatus;
  className?: string;
};

/**
 * The save-state glyph every Input2 control shows for its `status`: a spinner while saving, a
 * check that pops in on success, a shaking warning on error. One copy, so a saved input, button and
 * switch all read the same.
 */
export default function UpdateStatusIcon({ status, className }: UpdateStatusIconProps) {
  if (status === 'updating') return <WaveSpinner className={cn('size-full', className)} />;
  if (status === 'success') {
    return (
      <>
        <style>{`@keyframes check-pop { 0% { transform: scale(0); } 50% { transform: scale(1.2); } 100% { transform: scale(1); } }`}</style>
        <General.CheckCircle
          className={cn('size-full text-green-500', className)}
          style={{ animation: 'check-pop 0.3s ease-out forwards' }}
        />
      </>
    );
  }
  return (
    <>
      <style>{`@keyframes error-shake { 0%, 100% { transform: translateX(0); } 20%, 60% { transform: translateX(-2px); } 40%, 80% { transform: translateX(2px); } }`}</style>
      <Alerts.AlertTriangle
        className={cn('size-full text-red-500', className)}
        style={{ animation: 'error-shake 0.4s ease-out forwards' }}
      />
    </>
  );
}
